export default __webpack_public_path__ + "static/media/19_1_1.56da98c8.png";